/**
 * Páginas puente de MSAL v5. Corren fuera de los providers de la app (sin MsalProvider) y el proxy
 * las sirve sin exigir sesión: llegan con la respuesta o la solicitud de Entra en el hash, y una
 * redirección o una hidratación de más la perderían.
 *
 * Sin imports a propósito: lo usa `src/proxy.ts`, que corre en el servidor y no puede arrastrar
 * `@azure/msal-browser`.
 */
export const REDIRECT_BRIDGE_PATH = '/redirect'

/**
 * Relevo del popup para la app embebida en un iframe de otro sitio (Salesforce).
 * Ver `src/app/popup-relay/page.tsx`.
 */
export const POPUP_RELAY_PATH = '/popup-relay'

const RUTAS_PUENTE: readonly string[] = [REDIRECT_BRIDGE_PATH, POPUP_RELAY_PATH]

export const esRutaPuenteMsal = (pathname: string): boolean => RUTAS_PUENTE.includes(pathname)
